import { Message } from "../message.model";

export interface BaseHeatMapZone {
  sector: string;
  sucursal: string;
  tipo_acceso: 'interna' | 'perimetral';
  Tipo_consulta_BD: string;
  fecha_inicial?: string;
  fecha_final?: string;
  mes_inicial?: string;
  mes_final?: string;
  mes_actual?: string;
  mes_anterior?: string;
  anio_actual?: string;
  anio_anterior?: string;
}

// El back conserva el nombre 'Acceso' para la zona, igual que en por_zona
export interface HeatMapZoneData extends Record<string, string | number> {
  Hora: string;
  Acceso: string;
  value: number;
}

export interface ResponseHeatMapZone {
  column_name:
    | {
        heatmapData: HeatMapZoneData[];
      }
    | Message;
}
